import React, { useEffect, useRef, useState } from "react";
import ReactDOM, { createPortal } from 'react-dom';
import Icon from '../atoms/Icon';

const Modal = ({ onClose, children, video = false, translations, wide=false, medium=false }) => {
  const container = useRef();

  useEffect(() => {
    document.body.classList.add('u-no-scroll');
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  const handleClickOutside = event => {
    if (!container.current.contains(event.target)) {
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    document.body.classList.remove('u-no-scroll');
    onClose();
  };

  return (
    <div className="o-modal">
      <div className={ "o-modal__wrapper" + (video || wide ? " o-modal__wrapper--wide" : "") + (medium ? " o-modal__wrapper--medium" : "") } ref={ container }>
        <button onClick={ handleCloseModal } className="o-modal__close a-btn">
          <Icon iconName="icon-cross" className="o-modal__icon a-icon a-icon--xs"/>
          <span className="u-visually-hidden">{ (translations && translations.close ? translations.close : "Close") }</span>
        </button>
        <div className={ "o-modal__container" + (video ? " o-modal__container--full" : "") } id="modal">
          { children }
        </div>
      </div>
    </div>
  );
};

// When we use ReactDOM.render to populate the content of the modal we no longer have access to context providers.
// Link.js is depentent on PagesContext context to work when it's an intenal link to a subpage. But that information is
// lost when we call ReactDom.render
export default props => {
  const modalElement = document.getElementById('modal');

  ReactDOM.render(
    <Modal onClose={ () => ReactDOM.render(null, modalElement) }
           video={ props.video } translations={props.translations} gallery={props.gallery} wide={props.wide} medium={props.medium}>{ props.children }</Modal>, modalElement);
}

// This way we don't have to use ReactDOM.render to render the content of the modal with the added benefing that we now still have
// access to the context providers so links to subpages will work as expected.

// Returns text link that opens the modal
export const OpenModal = ( props ) => {

  const modalElement = document.getElementById('modal');
  const [showModal, setShowModal] = useState(false);

  return (

    <>
      <a className={props.className} onClick={ () => setShowModal(true) }>{ props.readMore }</a>
      {showModal && createPortal(
        <Modal  onClose={ () => setShowModal(false) } 
                video={props.video} 
                translations={props.translations} 
                gallery={props.gallery}>{ props.modalContent }
        </Modal>,
        modalElement
      )}
    </>
  )    
}

// If an entire div should be the trigger for the modal 

export const OpenModalTrigger = ( props ) => {

  const modalElement = document.getElementById('modal');
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className={props.className} onClick={ () => setShowModal(true) }>{ props.children }</div>

      {showModal && createPortal(
        <Modal  onClose={ () => setShowModal(false) } 
                video={props.video} 
                translations={props.translations} 
                gallery={props.gallery}>{ props.modalContent }
        </Modal>,
        modalElement
      )}
    </>
  )
}